import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import heroImage from "../../assets/banking-hero.webp";

function Banking() {
  const [offsetY, setOffsetY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setOffsetY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* ================= HERO ================= */}
      <section className="relative h-[70vh] flex items-center justify-center">

        {/* BACKGROUND IMAGE */}
        <div
          className="absolute inset-0 bg-cover bg-center scale-105 will-change-transform"
          style={{
            backgroundImage: `url(${heroImage})`,
            transform: `translateY(${offsetY * 0.2}px)`
          }}
        ></div>

        {/* DARK OVERLAY */}
        <div className="absolute inset-0 bg-black/60"></div>

        {/* CONTENT */}
        <div className="relative z-10 text-center text-white px-6 max-w-3xl">
          <h1 className="text-4xl md:text-6xl font-dancing-script">
            Banking & Securities Law
          </h1>

          <p className="mt-4 text-lg text-gray-200">
            Strategic legal solutions for financial institutions, corporations, and investment operations.
          </p>
        </div>

      </section>

      {/* ================= INTRO TEXT ================= */}
      <section className="bg-white py-16 px-6">
        <div className="max-w-4xl mx-auto text-center">

          <p className="font-dancing text-lg md:text-xl text-gray-800 leading-relaxed">
            Our Banking and Securities Law practice provides comprehensive legal support to financial institutions,
            investment firms, corporations, and individual clients operating within highly regulated financial
            environments. We advise on a wide range of matters including banking transactions, credit facilities,
            loan agreements, regulatory compliance, securities offerings, and corporate finance structures. Our goal
            is to ensure that every financial arrangement is legally sound, properly structured, and aligned with both
            local and international financial regulations.
          </p>

          <p className="mt-8 font-dancing text-lg md:text-xl text-gray-800 leading-relaxed">
            We also assist clients in navigating complex regulatory frameworks governed by financial authorities,
            helping them remain compliant while minimizing legal, operational, and financial risks. Whether it involves
            structuring corporate financing, advising on capital market transactions, conducting due diligence, or
            resolving disputes in banking relationships, we provide precise and strategic legal guidance. Our approach
            combines technical legal expertise with a deep understanding of financial systems to support secure,
            efficient, and sustainable financial growth for our clients.
          </p>

        </div>
      </section>

      {/* ================= NAV BUTTONS ================= */}
      <section className="py-12 px-6 bg-gray-100 border-t border-gray-200">
        <div className="max-w-7xl mx-auto flex justify-between items-center">

          {/* LEFT BUTTON */}
          <Link
            to="/services"
            className="px-6 py-3 border border-[#0B3D91] text-[#0B3D91] rounded-lg font-semibold hover:bg-[#0B3D91] hover:text-white transition hover:-translate-x-1"
          >
            ← Back to Practice Areas
          </Link>

          {/* RIGHT BUTTON */}
          <Link
            to="/services/litigation"
            className="px-6 py-3 bg-[#0B3D91] text-white rounded-lg font-semibold hover:bg-blue-800 transition hover:translate-x-1"
          >
            Next Area →
          </Link>

        </div>
      </section>
    </>
  );
}

export default Banking;